const template = require('./dialog.html.slim');

angular.module('wbComponents').directive('wbDialog', ['$animate', function wbDialog($animate) {
  return {
    scope: {
      onConfirm: '&',
      onCancel: '&',
      altLinkClick: '&',
      altLinkTitle: '@',
      noCloseBox: '@',
      title: '@',
      confirmLabel: '@',
      cancelLabel: '@',
      dialog: '@',
      overlayDisabled: '=',
    },
    restrict: 'E',
    replace: true,
    transclude: true,
    templateUrl: template,
    bindToController: true,
    controllerAs: 'dialog',
    controller() {
      this.visible = false;
      this.show = (data) => {
        this.visible = true;
        this.data = data;
      };

      this.hide = () => {
        this.visible = false;
        this.data = null;
      };

      this.cancel = () => {
        this.onCancel({ data: this.data });
        this.hide();
      };

      this.overlayClick = () => {
        if (!this.overlayDisabled) {
          this.cancel();
        }
      };

      this.confirm = () => {
        if (this.visible) {
          this.onConfirm({ data: this.data });
          this.hide();
        }
      };
    },

    link($scope, $el, $attrs, dialog) {
      $scope.dialog = dialog;
      if ($attrs.contained !== 'true') {
        $el.prependTo('body');
      }
      dialog.isConfirm = ($attrs.onConfirm != null);
      $scope.$parent[$attrs.name] = dialog;
      let position = 0;
      $el.addClass('ng-hide');
      $scope.$watch('dialog.visible', (value) => {
        if (value) {
          $animate.removeClass($el, 'ng-hide', { tempClasses: 'ng-hide-animate' }).then(() => {
            if (value) {
              position = $('body').scrollTop();
              $('body').addClass('dialog-visible');
            }
          });
        } else {
          $('body').removeClass('dialog-visible');
          $('body').scrollTop(position);
          $animate.addClass($el, 'ng-hide', { tempClasses: 'ng-hide-animate' });
        }
      });

      return $scope.$on('$destroy', () => $el.remove());
    },
  };
},
]);
